// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"926c09e1","141":"f4d339b9","344":"ab407142","936":"f168c2bc"}[chunkId] + ".chunk.css";
};